import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeedAdviceModuleState } from '../models/feed-advice.model';

export const getFeedAdviceModuleState =
  createFeatureSelector<FeedAdviceModuleState>('feedAdviceModule');

export const getSelectedLocations = createSelector(
  getFeedAdviceModuleState,
  (state) => state.locations,
);
export const getFeedAdvices = createSelector(
  getFeedAdviceModuleState,
  (state) => state.feedAdvices,
);
export const getFeedAdvicesFromReference = createSelector(
  getFeedAdviceModuleState,
  (state) => state.feedAdvicesFromReference,
);
export const getSelectedFeedAdvice = createSelector(
  getFeedAdviceModuleState,
  (state) => state.selectedFeedAdvice,
);
export const getReferenceFeedAdvice = createSelector(
  getFeedAdviceModuleState,
  (state) => state.referenceFeedAdvice,
);

export const getSelectedCountry = createSelector(
  getFeedAdviceModuleState,
  (state) => state.selectedCountry,
);

export const getSelectedFeedAdviceType = createSelector(
  getFeedAdviceModuleState,
  (state) => state.feedAdviceType,
);
export const getSelectedFeedAdviceTypes = createSelector(
  getFeedAdviceModuleState,
  (state) => state.selectedFeedadviceTypes,
);
export const getShowLysineSetting = createSelector(
  getFeedAdviceModuleState,
  (state) => state.showLysine,
);
export const getShowEnergySetting = createSelector(
  getFeedAdviceModuleState,
  (state) => state.showEnergy,
);

export const getShowDosatorSetting = createSelector(
  getFeedAdviceModuleState,
  (state) => state.showDosator,
);

export const getSelectedFeedAdviceId = createSelector(
  RouterSelectors.getRouteParam('id'),
  (feedAdviceId) => {
    const routeId = parseInt(feedAdviceId ?? '', 10);
    if (!isNaN(routeId) && routeId > 0) {
      return routeId;
    }

    return null;
  },
);
